<!--  -->
<template>
  <div class="tem-all" >
    <component v-bind:is="currentComponent" :temData="temData"></component>
  </div>
</template>

<script>
import banner from '@/components/Banner'
import progressTem from '@/views/home/progressTem'
import imgTem from '@/views/home/imgTem'
import texTem from '@/views/home/texTem'
import subjectTem from '@/views/home/subjectTem'
import reg from '@/views/home/reg'

export default {
  props: {
    temData: {
      type: Object
    }
  },

  computed: {
    currentComponent() {
      switch (this.temData.moduleType) {
        case 1: 
          return banner
        case 2:
          return progressTem
        case 3:
          return texTem
        case 4:
          return imgTem
        case 5:
          return subjectTem
        case 6:
          return reg
        default:
          break;
      }
      return false
    },
    genBgStyle() {
      const defaultStyle = {
          background: '#FCF1D5'
      }
      if(!this.temData.bgDataUrl || this.temData.moduleType === 1) return defaultStyle
      return {
        'background-image':'url('+this.temData.bgDataUrl+')',
        'background-size': 'cover',
        'background-position': 'center',
        'background-repeat': 'no-repeat',
      }
    }
  },

}

</script>
<style lang='less' scoped>
.tem-all {
  background: transparent;
} 
</style>